/* eslint-disable import/no-anonymous-default-export */
// import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { CREATE_KHO_HANG, GET_DANH_SACH_KHO, UPDATE_DEFAULT_KHO_HANG, UPDATE_KHO_HANG, UPDATE_STATUS_KHO_HANG } from './constant';
import { getListKhoHangApi, postCreateListKhoHangApi, postUpdateDefaultKhoHangApi, postUpdateKhoHangApi, postUpdateStatusKhoHangApi } from './helpers';
import { GetDanhSachKhoActionDone } from './action';

function* takeGetListKhoHangSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getListKhoHangApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(GetDanhSachKhoActionDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostCraeteKhoHangSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postCreateListKhoHangApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostUpdateKhoHangSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postUpdateKhoHangApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostUpdateDefaultKhoHangSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postUpdateDefaultKhoHangApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostUpdateStatusKhoHangSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postUpdateStatusKhoHangApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function* () {
  yield takeLatest(GET_DANH_SACH_KHO, takeGetListKhoHangSaga);
  yield takeLatest(CREATE_KHO_HANG, takePostCraeteKhoHangSaga);
  yield takeLatest(UPDATE_KHO_HANG, takePostUpdateKhoHangSaga);
  yield takeLatest(UPDATE_DEFAULT_KHO_HANG, takePostUpdateDefaultKhoHangSaga);
  yield takeLatest(UPDATE_STATUS_KHO_HANG, takePostUpdateStatusKhoHangSaga);
}

